// Added By : bhautik
// Created At: 28-5-2024
// Description: routing files
// Ticket ID: 001

import { lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import AuthRoutes from "./AuthRoute";
import AdminRoutes from "./AdminRoute";
import organizationalStructureRoutes from "./organizationalStructureRoutes";
import EmployeeRoutes from "./EmployeeRoutes";
import { useSelector } from "react-redux";
import PageLoader from "../components/PageLoader";
import HrRoutes from "./HrRoute";
const PageNotFound = lazy(() => import("../components/PageNotFound"));
const Layoat = lazy(() => import("../modules/layout/Layoat"));
const Company = lazy(() => import("../modules/admin/company"));

const Router = () => {
  const { selectedCompany } = useSelector((state) => state?.auth);
  // Define public routes
  const publicRoutes = [...AuthRoutes];

  // Define private routes
  const privateRoutes = [
    {
      path: "/", // Layout path
      element: (
        <PrivateRoute>
          <Layoat />
        </PrivateRoute>
      ),
      children: [
        // Child routes within the layout
        {
          path: "/", // Redirect root to dashboard if token present
          element: <Navigate to="/dashboard" />,
        },
        ...AdminRoutes,
        ...HrRoutes,
        ...organizationalStructureRoutes,
        ...EmployeeRoutes,
        // Add more private routes as needed
      ],
    },
  ];

  // Merge public and private routes
  const routes = useRoutes([
    ...publicRoutes,
    ...privateRoutes,
    {
      path: "*",
      element: (
        <Suspense>
          <PageNotFound />
        </Suspense>
      ),
    },
  ]);

  // Merge public and company management routes (used for adming when his company is inactive)
  const inactiveCompanyRoutes = useRoutes([
    {
      path: "/", // Layout path
      element: (
        <PrivateRoute>
          <Layoat />
        </PrivateRoute>
      ),
      children: [
        {
          path: "/admin/company",
          element: (
            <Suspense fallback={<PageLoader />}>
              <PrivateRoute requiredRoles={["MASTERADMIN", "ADMIN"]}>
                <Company />
              </PrivateRoute>
            </Suspense>
          ),
        },
        {
          path: "*",
          element: <Navigate to="/admin/company" />,
        },
      ],
    },
    ...publicRoutes,
  ]);

  if (!selectedCompany?.is_active) {
    return inactiveCompanyRoutes;
  }

  return routes;
};

export default Router;
